const binding = { modules: {}, dataActions: {} };

    (binding.modules['herbal-order-infographic'] = {
        c: () => require('partner/modules/herbal-order-infographic/herbal-order-infographic.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'herbal-order-infographic',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/herbal-order-infographic'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|herbal-order-infographic|herbal-order-infographic'] = {
                c: () => require('partner/modules/herbal-order-infographic/herbal-order-infographic.view.tsx'),
                cn: '__local__-__local__-herbal-order-infographic'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };